import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearClubsFilters,
  ClubCodeChanged,
  ClubEndDateChanged,
  ClubEndDateCleared,
  ClubNameChanged,
  ClubStartDateChanged,
  ClubStartDateCleared,
  ShowInactiveClubsChanged,
} from '../actions/clubs-search.actions';
import { ClubsSearchState } from '../models/clubs.models';

const initialState: ClubsSearchState = {
  panelExpanded: true,
  clubName: '',
  clubCode: '',
  clubStartDate: new Date(0),
  clubStartDateFormat: '',
  clubEndDate: new Date(0),
  clubEndDateFormat: '',
  showInactiveClubs: false,
};

export const ClubsSearchReducer = createReducer(
  initialState,
  on(ClubNameChanged, (state, { clubName }) => ({
    ...state,
    clubName,
  })),
  on(ClubCodeChanged, (state, { clubCode }) => ({
    ...state,
    clubCode,
  })),
  on(ClubStartDateChanged, (state, { clubStartDate, clubStartDateFormat }) => ({
    ...state,
    clubStartDate,
    clubStartDateFormat,
  })),
  on(ClubStartDateCleared, (state) => ({
    ...state,
    clubStartDate: new Date(0),
    clubStartDateFormat: '',
  })),
  on(ClubEndDateChanged, (state, { clubEndDate, clubEndDateFormat }) => ({
    ...state,
    clubEndDate,
    clubEndDateFormat,
  })),
  on(ClubEndDateCleared, (state) => ({
    ...state,
    clubEndDate: new Date(0),
    clubEndDateFormat: '',
  })),
  on(ShowInactiveClubsChanged, (state) => ({
    ...state,
    showInactiveClubs: !state.showInactiveClubs,
  })),
  on(ActiveComponentChanged, ClearClubsFilters, () => ({
    ...initialState,
  })),
);
